module.exports = __webpack_public_path__ + "media/main.66ac8986.mp3";